import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { ProductService } from './product.service';
import { FieldActivityPlanCostProduct } from '../_models/fieldActivityPlanCostProduct';
import { FieldActivityPlan } from '../_models/fieldActivityPlan';

@Injectable()
export class FieldActivityPlanCostProductService {
  constructor(private productService: ProductService) {}

  getAllTemporaryCostProductsFromPlan(
    fieldActivityPlan: FieldActivityPlan,
    unitPrice: number,
    unit: string,
    hectaresSize
  ): Array<FieldActivityPlanCostProduct> {
    // tslint:disable-next-line: prefer-const
    const results: Array<FieldActivityPlanCostProduct> = [];
    const cropSize = fieldActivityPlan.crops.length;
    _.each(fieldActivityPlan.programs, (program: any) => {
      _.each(program.activities, (activity: any) => {
        const { type } = activity;
        if (type === 'defending' || type === 'feeding' || type === 'seeding') {
          activity.mixes.forEach((mix) => {
            // tslint:disable-next-line:prefer-const
            const fapcpTMP = new FieldActivityPlanCostProduct();
            if (mix.product && mix.product.id) {
              // tslint:disable-next-line:prefer-const
              const prodObj = this.productService.getProductById(mix.product.id);
              if (prodObj && prodObj.name) {
                fapcpTMP.name = prodObj.name;
              }
            }
            fapcpTMP.product = mix.product;
            fapcpTMP.quantity = mix.dose * hectaresSize;
            fapcpTMP.quantityUnit = mix.doseUnit;
            fapcpTMP.unitPrice = unitPrice ? unitPrice : 0;
            fapcpTMP.unit = unit ? unit : 'currency_ha';
            // tslint:disable-next-line:max-line-length
            fapcpTMP.amount =
              fapcpTMP.unitPrice !== null && fapcpTMP.quantity !== null
                ? fapcpTMP.quantity * fapcpTMP.unitPrice
                : 0;
            results.push(fapcpTMP);
          });
        }
      });
    });
    return results;
  }
}
